import serviceBase from 'app/Services/serviceBase'
import { EmptyTagsTypes } from 'app/Constants/bodyTextValidationsTypes'
const handleChangeForAlertState = (evt, AlertSetter) => {
  const value = evt.target.value
  AlertSetter((prevState) => ({ ...prevState, [evt.target.name]: value }))
}

const INITIAL_STATE = {
  images: [],
  isDiscarded: false,
  title: '',
  positionFiles: 0,
  bodyText: '',
  filesToUpdate: [],
  posted: false,
  errors: {
    titleError: '',
    bodyTextError: ''
  }
}

function getImagesPayload(images) {
  const imgPayload = []

  images.forEach((image) => {
    imgPayload.push({
      originalName: image.originalName,
      caption: image.caption,
      type: image.type,
      fileSize: image.fileSize,
      binary: image.file
    })
  })

  return { imgPayload }
}

const fieldValidator = (title, bodyText, AlertSetter) => {
  let ready = true
  if (title.length === 0) {
    AlertSetter((prevState) => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        titleError: 'This Field is Required!'
      }
    }))
    ready = false
  }

  const trimmed = (bodyText || '').trim()
  if (!trimmed || EmptyTagsTypes.EmptyTag.includes(trimmed)) {
    AlertSetter((prevState) => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        bodyTextError: 'This Field is Required!'
      }
    }))
    ready = false
  }

  setTimeout(() => {
    AlertSetter((prevState) => ({
      ...prevState,
      errors: {
        titleError: '',
        bodyTextError: ''
      }
    }))
  }, 5000)
  return { ready }
}
const removeAsset = (file, images, setter) => {
  const newImages = images.filter((img) => img.fileName !== file.fileName)
  setter((prevState) => ({
    ...prevState,
    images: newImages
  }))
}
const timeOutter = setAlertState => {
  setTimeout(() => {
    setAlertState((prevState) => ({
      ...prevState,
      isDiscarded: false
    }))
  }, 100)

  setTimeout(() => {
    setAlertState((prevState) => ({
      ...prevState,
      posted: false
    }))
  }, 5000)
}
const postAlertRequest = async (formData, iarMember, setAlertState, errorSnackBarActions) => {
  try {
    let url = `${window._env_.COMMUNITY_API_URL}/alert/alert`
    await serviceBase.post(url, formData, {
      fullusername: iarMember.fullName
    })
    setAlertState({ ...INITIAL_STATE, isDiscarded: true, posted: true })
    timeOutter(setAlertState)
    
  } catch (error) {
    console.error(error)
    errorSnackBarActions.setOpen(true)
  }
}
export {
  handleChangeForAlertState,
  INITIAL_STATE,
  removeAsset,
  fieldValidator,
  getImagesPayload,
  postAlertRequest
}
